import CreateRechargeTransactionRequestModelBase from '../_generated/modelBases/create-recharge-transaction-request-model-base';

export default class CreateRechargeTransactionRequestModel extends CreateRechargeTransactionRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
